import React, { useCallback, useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { fetchClientData } from "../../redux/client/clientSlice";
import { useDispatch } from "react-redux";
import { parse, isValid } from "date-fns";
import socket from "../../context/socket";
import _ from "lodash";
import api from "../../utils/api";
import Swal from "sweetalert2";

const NomineeDetailsForm = ({
  show,
  onHide,
  proofType,
  roomId,
  clientData,
  kycDoc,
  setAlertMessage,
  alertMessage,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
const dispatch = useDispatch()
  const [dob, setDob] = useState(null);
  const [isDataAvailable, setDataAvailable] = useState(false);
  const [isOtp, setOtp] = useState("");
  const [otpRequested, setOtpRequested] = useState(false);
  const [age,setAge] = useState(0)

  console.log("Date of birth", dob,age)

  function calculateAge(dob) {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();

    // Adjust if birthday hasn't occurred yet this year
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  useEffect(() => {
    setAge(calculateAge(dob))
  },[dob])


  useEffect(() => {
    if (!roomId) return;
  
    if (show === false) {
      // Emit `show: false` first
      socket.emit("message_to", {
        room: roomId,
        data: { show: false },
      });
  
      // Emit all nominee fields as empty
      const fieldsToClear = [
        "nominee_name",
        "guardian_name",
        "nominee_mobile",
        "nominee_relation",
        "nominee_email",
        "nominee_address_proof",
        "nominee_address_no",
        "nominee_address",
        "nominee_city",
        "nominee_pincode",
        "nominee_country",
        "nominee_dob",
      ];
  
      fieldsToClear.forEach((field) => {
        socket.emit("message_to", {
          room: roomId,
          data: {
            type: "nominee_field_update",
            field,
            value: "",
          },
        });
      });
  
      console.log("Emitted all nominee fields as empty due to show=false");
    } else {
      // If show is true, just emit the show flag
      socket.emit("message_to", {
        room: roomId,
        data: { show: true },
      });
    }
  }, [show, roomId]);
  
  useEffect(() => {
    const nomineeDoc = kycDoc?.find((item) => item.doctype === "nominee_details") || {};
    const data = nomineeDoc.data?.[0] || null;
  
    if (data) {
      setDataAvailable(true);
  
      const fields = {
        nominee_name: data.nominee_name || "",
        guardian_name: data.guardian_name || "",
        nominee_mobile: data.nominee_mobile || "",
        nominee_relation: data.nominee_relation || "",
        nominee_email: data.nominee_email || "",
        nominee_address_proof: data.nominee_address_proof || "",
        nominee_address_no: data.nominee_address_no || "",
        nominee_address: data.nominee_address || "",
        nominee_city: data.nominee_city || "",
        nominee_pincode: data.nominee_pincode || "",
        nominee_country: data.nominee_country || "",
      };
  
      // Set values and emit for each field
      Object.entries(fields).forEach(([field, value]) => {
        setValue(field, value);
        emitNomineeField(field, value);
      });
  
      // Handle DOB separately
      if (data?.nominee_dob) {
        const parsed = moment(data?.nominee_dob);
        if (parsed.isValid()) {
          const dobValue = parsed.toDate();
          setDob(dobValue);
          setValue("nominee_dob", data.nominee_dob);
          emitNomineeField("nominee_dob", data?.nominee_dob);
        }
      }
    } else {
      setDataAvailable(false);
    }
  }, [clientData, kycDoc, setValue, roomId,show]);
  
  const emitNomineeField = (field, value) => {
    if (roomId && socket && field && show) {
      socket.emit("message_to", {
        room: roomId,
        data: {
          show,
          type: "nominee_field_update",
          field,
          value,
        },
      });
      console.log(`Emitted: ${field} = ${value}`);
    }
  };
  
  
  const onSubmit = async (formData) => {
    const allData = {
      ...formData,
      nominee_dob: dob,
      nominee_mother_name: "",
      nominee_guardian_name: age < 18 ? formData.guardian_name : "", // 👈 this line ensures empty if 18+
      _id: roomId,
      client_email: clientData.email,
      data_status: true,
    };
        Swal.fire({
          text: "Please wait...",
          imageUrl: "https://www.finedge.in/assets/images/download.gif",
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

    console.log('allData',allData);
    

    try {
      const response = await api.post(
        `advisor/update_nominee_data`,
        allData
      );
      if (response.status ===200||response.status===201) {
        Swal.fire({
          icon: "success",
          text: response?.message || "Client data updated successfully",
          title: "Success",
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        }).then(() => {
          setValue("");
          reset();
          onHide();
          dispatch(fetchClientData(roomId));
    
          socket.emit("join", { room: roomId });
          socket.emit("message_to", 
            {
              room: roomId,
              data: { message: response?.message || "Client data updated successfully",
              type: "success",}
            
            })
          console.log("emitted data message_to", roomId, "success");
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: response.data?.message || 'Something went wrong!',
          confirmButtonColor: '#d33',
        });
      }
    } catch (error) {
      console.error("Error updating nominee details:", error);
      // Show error alert
      setAlertMessage({
        visible: true,
        message:
          "An error occurred while updating nominee details. Please try again.",
        variant: "danger",
      });
    }
  };


  const handleBlur = (field, value) => {
    if (!roomId || !field) return;
  
    socket.emit("message_to", {
      room: roomId,
      data: {
        show,
        type: "nominee_field_update",
        field,
        value,
      },
    });
  
    console.log("Emitted field:", field, "Value:", value);
  };
  




  return (
    <>
      <Modal show={show} onHide={onHide} size="md">
        <Modal.Header closeButton style={{ backgroundColor: "#c7e69b" }}>
          <Modal.Title>{proofType} Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* Bootstrap Alert */}
            {alertMessage.visible && (
              <Alert
                variant={alertMessage.variant}
                onClose={() =>
                  setAlertMessage({ ...alertMessage, visible: false })
                }
                dismissible
              >
                {alertMessage.message}
              </Alert>
            )}

            {/* Full Name and Relationship */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="nominee_name">
                  <Form.Label>Nominee Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter full name"
                    disabled={alertMessage.visible}
                    {...register("nominee_name", {
                      required: "Full Name is required",
                    })}
                     onBlur={(e) => handleBlur("nominee_name", e.target.value)}
                  />
                  {errors.nominee_name && (
                    <span className="text-danger">
                      {errors.nominee_name.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="nominee_relation">
                  <Form.Label>Relationship</Form.Label>
                  <Form.Control
                    as="select"
                    disabled={alertMessage.visible}
                    {...register("nominee_relation", {
                      required: "Relationship is required",
                    })}
                    onBlur={(e) => handleBlur("nominee_relation", e.target.value)}

                  >
                    <option value="">Select Relationship</option>
                    <option value="Spouse">Spouse</option>
                    <option value="Son">Son</option>
                    <option value="Daughter">Daughter</option>
                    <option value="Father">Father</option>
                    <option value="Mother">Mother</option>
                    <option value="Brother">Brother</option>
                    <option value="Sister">Sister</option>
                  </Form.Control>
                  {errors.nominee_relation && (
                    <span className="text-danger">
                      {errors.nominee_relation.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
            </Row>

            {/* Date of Birth (with DatePicker) */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="nominee_dob">
                  <Form.Label className="d-block ">Date of Birth</Form.Label>
                  <DatePicker
                    selected={dob}
                    disabled={alertMessage.visible}
                    onChange={(date) => {
                      setDob(date);
                      handleBlur("nominee_dob", moment(date).format("YYYY-MM-DD"));
                    }}
                    className="form-control w-100"
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select date of birth"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select" // Allows selecting from dropdowns
                  />
                  {errors.nominee_dob && (
                    <span className="text-danger">
                      {errors.nominee_dob?.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="guardian_name">
                  <Form.Label>Guardian Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={age<18?"Enter guardian's name":""}
                    disabled={age >= 18 || alertMessage.visible}
                    {...register("guardian_name", {
                      required: age < 18 ? "Guardian's Name is required" : false, 
                    })}
                    onBlur={(e) => handleBlur("guardian_name", e.target.value)}
                  />
                  {errors.guardian_name && (
                    <span className="text-danger">
                      {errors.guardian_name.message}
                    </span>
                  )}
                </Form.Group>
              </Col>


            </Row>

            {/* Mobile Number and email  */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="nominee_mobile">
                  <Form.Label>Nominee's Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    disabled={alertMessage.visible}
                    placeholder="Enter mobile number"
                    {...register("nominee_mobile", {
                      required: "Mobile Number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter a valid 10-digit number",
                      },
                    })}
                    onBlur={(e) => handleBlur("nominee_mobile", e.target.value)}
                  />
                  {errors.nominee_mobile && (
                    <span className="text-danger">
                      {errors.nominee_mobile.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
              {otpRequested && (
                <Col md={6}>
                  <Form.Group controlId="otp">
                    <Form.Label>OTP</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter otp"
                      onChange={(e) => setOtp(e.target.value)}
                    />
                    {/* {errors.otp && <span className="text-danger">{errors.otp.message}</span>} */}
                  </Form.Group>
                </Col>
              )}

              <Col md={6}>
                <Form.Group controlId="nominee_email">
                  <Form.Label>Nominee's Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter Nominee's Email"
                    disabled={alertMessage.visible}
                    {...register("nominee_email", {
                      required: "Nominee Email is required",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Enter a valid email address",
                      },
                    })}
                    onBlur={(e) => handleBlur("nominee_email", e.target.value)}

                  />
                  {errors.nominee_email && (
                    <span className="text-danger">
                      {errors.nominee_email.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
            </Row>

            {/* Nominee Address Proof */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="nominee_address_proof">
                  <Form.Label>Nominee's Address Proof</Form.Label>
                  <Form.Control
                    as="select"
                    disabled={alertMessage.visible}
                    {...register("nominee_address_proof", {
                      required: "Address Proof is required",
                    })}
                    onBlur={(e) => handleBlur("nominee_address_proof", e.target.value)}

                  >
                    <option value="">Select</option>
                    <option value="1">PAN Card</option>
                    <option value="2">Aadhar Card</option>
                    <option value="3">Driving Licence</option>
                  </Form.Control>
                  {errors.nominee_address_proof && (
                    <span className="text-danger">
                      {errors.nominee_address_proof.message}
                    </span>
                  )}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="nominee_address_no">
                  <Form.Label>Card Number</Form.Label>
                  <Form.Control
                    type="text"
                    disabled={alertMessage.visible}
                    placeholder="Enter Card Number"
                    {...register("nominee_address_no", {
                      required: "Card Number is required",
                      pattern: {
                        value: /^[A-Za-z0-9]{4,20}$/,
                        message: "Enter a valid card number",
                      },
                    })}
                    onBlur={(e) => handleBlur("nominee_address_no", e.target.value)}

                  />
                  {errors.nominee_address_no && (
                    <span className="text-danger">
                      {errors.nominee_address_no.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
            </Row>

            {/* Nominee Address */}
            <Row className="mb-3">
              <Col md={12}>
                <Form.Group controlId="nominee_address">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    disabled={alertMessage.visible}
                    placeholder="Enter Full Address"
                    {...register("nominee_address", {
                      required: "Address is required",
                    })}
                    onBlur={(e) => handleBlur("nominee_address", e.target.value)}

                  />
                  {errors.nominee_address && (
                    <span className="text-danger">
                      {errors.nominee_address.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="nominee_city">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    disabled={alertMessage.visible}
                    placeholder="Enter City"
                    {...register("nominee_city", {
                      required: "City is required",
                    })}
                    onBlur={(e) => handleBlur("nominee_city", e.target.value)}

                  />
                  {errors.nominee_city && (
                    <span className="text-danger">
                      {errors.nominee_city.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="nominee_pincode">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="text"
                    disabled={alertMessage.visible}
                    placeholder="Enter Pincode"
                    {...register("nominee_pincode", {
                      required: "Pincode is required",
                      pattern: {
                        value: /^[0-9]{6}$/,
                        message: "Enter a valid 6-digit pincode",
                      },
                    })}
                    onBlur={(e) => handleBlur("nominee_pincode", e.target.value)}

                  />
                  {errors.nominee_pincode && (
                    <span className="text-danger">
                      {errors.nominee_pincode.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="nominee_country">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    type="text"
                    disabled={alertMessage.visible}
                    placeholder="Enter Country"
                    {...register("nominee_country", {
                      required: "Country is required",
                    })}
                    onBlur={(e) => handleBlur("nominee_country", e.target.value)}

                  />
                  {errors.nominee_country && (
                    <span className="text-danger">
                      {errors.nominee_country.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Modal.Footer className="border-0">
              {otpRequested && <Button variant="success">Verify</Button>}

           
                  <Button variant="secondary" onClick={onHide}>
                    Close
                  </Button>
                  <Button variant="success" type="submit">
                    {isDataAvailable ? "Update" : "Submit"}
                  </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NomineeDetailsForm;
